module.exports = __webpack_public_path__ + "media/images/game_icon/th/AB1050-9786fe9c49316069d73485296884ad51.png";